import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, FormattedPlural } from 'react-intl'

import {
  quests as questsMessage,
  quest,
  match,
  matches,
  yourSearch
} from '../../utils/messages'

export default class QuestsSearchResultsCount extends Component {
  render() {
    const { totalQuests } = this.props

    return (
      <div className="quests-search-results-count">
        <div className="results-found">
          <FormattedMessage
            id={'Quests.QuestsFound'}
            defaultMessage={'{totalQuests} {quests} {match} {yourSearch}.'}
            values={{
              totalQuests: totalQuests,
              quests: (
                <FormattedPlural
                  value={totalQuests}
                  one={quest}
                  other={questsMessage}
                />
              ),
              match: (
                <FormattedPlural
                  value={totalQuests}
                  one={matches}
                  other={match}
                />
              ),
              yourSearch: yourSearch
            }}
          />
        </div>
      </div>
    )
  }
}

QuestsSearchResultsCount.propTypes = {
  totalQuests: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/components/mini/QuestsSearchResultsCount.js